import React from 'react';
import './_styles.scss';

const formatTimeDifference = (timestamp) => {
  if (!timestamp) return '';

  const now = new Date();
  const changeDate = new Date(timestamp);
  const diffMs = now - changeDate;

  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

  const parts = [];
  if (days > 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`);
  if (hours > 0) parts.push(`${hours} h`);
  if (minutes > 0 && days === 0) parts.push(`${minutes} min`);

  return parts.length > 0 ? parts.join(' ') : 'just now';
};

const formatTimestamp = (timestamp) => {
  if (!timestamp) return '';

  return new Date(timestamp).toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZone: 'UTC',
    timeZoneName: 'short',
  });
};

/**
 * OnlineBadge — displays online/offline state as Yes/No.
 *
 * Short variant (table cell):  <OnlineBadge online={value} />
 * Full variant  (detail form): <OnlineBadge label="Online" online={online} timestamp={onlineTs} showTimestamp />
 */
function OnlineBadge({ online, label, timestamp, showTimestamp = false }) {
  const badge = (
    <span className={`online-badge ${online ? 'online-badge--online' : 'online-badge--offline'}`}>
      <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <rect width="8" height="8" rx="4" fill="currentColor" />
      </svg>
      <span>{online ? 'Yes' : 'No'}</span>
    </span>
  );

  if (!label) return badge;

  return (
    <div className="staticField">
      <div className="label">
        {label}
        <div className="value">
          <div className="online-badge-container">
            {badge}
            {showTimestamp && timestamp && (
              <div className="online-badge-timestamp">
                <span className="online-badge-since">
                  {' (since '}
                  {formatTimestamp(timestamp)}
                  {', '}
                  {formatTimeDifference(timestamp)}
                  )
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnlineBadge;
